/**
 * Formatta un numero in formato italiano (migliaia con punto, decimali con virgola)
 */
export function formatNumberItalian(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "";
  }
  return new Intl.NumberFormat("it-IT", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

